import { indexItems } from '@/mocks/homeData';

const colorClasses: Record<string, { bg: string; text: string; border: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    border: 'border-primary-200',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    border: 'border-accent-200',
  },
  secondary: {
    bg: 'bg-secondary-200',
    text: 'text-secondary-700',
    border: 'border-secondary-300',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500">全品类影视内容分类导航，快速找到你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto">
          {indexItems.map((item) => {
            const colors = colorClasses[item.color];
            return (
              <a
                key={item.id}
                href="#cards"
                className={`group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl border ${colors.border} ${colors.bg} hover:scale-[1.03] transition-transform duration-200 cursor-pointer`}
              >
                <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center ${colors.bg}`}>
                  <i className={`${item.icon} ${colors.text} text-lg md:text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <span className="text-sm md:text-base font-semibold text-foreground-800 text-center whitespace-nowrap">{item.title}</span>
                <span className="text-xs text-foreground-400">{item.count}部</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}